module.exports = __webpack_public_path__ + "assets/img/Fotolia_145253345_XS.6557cb24.jpg";